import { reduxKey } from './constants';
import { FlagsObject, FlagPredicate } from '../types';
import { isFlagEnabled } from '../helpers';
import { createSelector } from 'reselect';

/**
 * Get all flags
 */
export const getFlags = (state): FlagsObject => {
  return state[reduxKey] || {};
};

/**
 * Check if flag is enabled
 */
export const flagEnabled = (state, flag: string | FlagPredicate) => {
  return isFlagEnabled(getFlags(state), flag);
};

/**
 * Get all flags
 */
export const getEnabledFlagsList = createSelector(getFlags, flags => {
  return Object.keys(flags).filter(flag => !!flags[flag]);
});
